const config = {
    prod: false,
    apiUrl: `https://geofa-test.geodanmark.dk/`,
    homepage: `/editor/`,
    vidiUri: `/app/fkg/?config=/api/v2/configuration/fkg/configuration_fkg_udgivet_5f465f5d3181f687353260.json`,
    vidiUriPhoto: `/app/fkg/?config=/api/v2/configuration/fkg/configuration_tilknyt_billeder_609933b8790e9035367682.json&leg=none&abo=none&mea=none&cle=none&scr=none`,
};

export default config;
